<template>
  <div>
    <c-table
      title="메일 발송 대상 목록"
      :columns="columns"
      :data="rows"
      gridHeight="450px"
      :autoFullHeight="false"
      :columnSetting="false"
      :filtering="true"
      :usePaging="false"
      :isExcelDown="false"
      :isFullScreen="false"
      :editable="false"
      selection="none"
      rowKey="mdmMaterialRegulatoryInfoHistoryMailId"
    />
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';

export default {
  name: 'chemUpdateHistoryMailUsers',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        mdmMaterialRegulatoryInfoHistoryDetailId: '',
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: 'auto',
    },
  },
  data() {
    return {
      listUrl: '',
      rows: [],
      columns: [
        {
          name: 'userName',
          field: 'userName',
          label: '사용자명',
          align: 'center',
          style: 'width:120px',
          sortable: true,
        },
        {
          name: 'empNo',
          field: 'empNo',
          label: '사번',
          align: 'center',
          style: 'width:120px',
          sortable: true,
        },
        {
          name: 'email',
          field: 'email',
          label: '이메일',
          align: 'left',
          style: 'width:220px',
          sortable: true,
        },
        {
          name: 'sendDt',
          field: 'sendDt',
          label: '발송일시',
          align: 'center',
          style: 'width:160px',
          sortable: true,
        },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.listUrl = selectConfig.chm.regul.updateHistory.mailUsers.url;
      this.getList();
    },
    /**
     * 상세별 메일 발송 대상 목록 조회
     */
    getList() {
      const historyDetailId = this.popupParam.mdmMaterialRegulatoryInfoHistoryDetailId;
      if (!historyDetailId) {
        this.rows = [];
        return;
      }
      this.$http.url = this.$format(this.listUrl, historyDetailId);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.rows = _result.data || [];
      });
    },
  },
};
</script>
